import { render, staticRenderFns } from "./TrainingData.vue?vue&type=template&id=a049afd4&scoped=true&"
import script from "./TrainingData.vue?vue&type=script&lang=js&"
export * from "./TrainingData.vue?vue&type=script&lang=js&"
import style0 from "./TrainingData.vue?vue&type=style&index=0&id=a049afd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a049afd4",
  null
  
)

export default component.exports